import React from 'react';
import { Col } from 'react-bootstrap';

const FormCol6 = (props) => (
  <Col sm={12} lg={6} xl={6} {...props}>
    {props.children}
  </Col>
);

export default FormCol6;

